import { render, staticRenderFns } from "./AssetDetailTemplateBuilder.vue?vue&type=template&id=54d14e78&scoped=true"
import script from "./AssetDetailTemplateBuilder.vue?vue&type=script&lang=js"
export * from "./AssetDetailTemplateBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d14e78",
  null
  
)

export default component.exports